import { Id } from 'new/api/types';
import { useQuery } from 'react-query';
import { getDisputes } from './endpoints';
import useActiveOffice from 'new/hooks/useActiveOffice';
import { useSidebarStore } from 'new/hooks/useSidebarStore';

const DISPUTES_REFETCH_INTERVAL = 60000;

export const useDisputes = (
  isDisputeCallDisabled: boolean,
  dentistInfoId?: Id,
) =>
  useQuery({
    queryKey: `DISPUTES_${dentistInfoId}`,
    queryFn: () =>
      getDisputes.endpoint({}, dentistInfoId).then((res) => res.data),
    enabled: !isDisputeCallDisabled && !!dentistInfoId,
    staleTime: Infinity,
    retry: 0,
    refetchInterval: DISPUTES_REFETCH_INTERVAL,
  });

export const useDisputesData = () => {
  const isDisputeCallDisabled = [
    'accounts/',
    'patient-details/',
    'external-patient-signup',
  ].some((path) => window.location.href.includes(path));

  const { activeOfficeId, isSuperAdmin, isLoadingUser } = useActiveOffice();
  const { data } = useDisputes(isDisputeCallDisabled, activeOfficeId);
  const { viewAsStandard } = useSidebarStore();

  const {
    hasDisputes,
    stripeRestricted,
    remediationLink,
    billingIssue,
    restrictionDate,
  } = data || {};

  const isVisibleDisputes =
    (hasDisputes || stripeRestricted || billingIssue) &&
    (!isSuperAdmin || viewAsStandard) &&
    !isLoadingUser;

  return {
    isVisibleDisputes,
    hasDisputes,
    stripeRestricted,
    billingIssue,
    remediationLink,
    restrictionDate,
  };
};
